module.exports = __webpack_public_path__ + "static/media/setpass2.fb9f896e.svg";